import {useTranslation} from '@aboutyou/i18n';
import {useHistory, useWishlistRoute} from '@aboutyou/router';
import {useTrackFeature} from '@aboutyou/tracking';
import {GenericIconName, useValueAfterHydration} from '@aboutyou/ui-components';
import {useWishlistBubbleColour, useWishlistCount} from '@aboutyou/user';
import React, {useMemo} from 'react';
import {IconMetaNavigationItem} from './IconMetaNavigationItem';

export const IconMetaNavigationItemWishlist: React.FC<{
  onClick: React.MouseEventHandler;
}> = ({onClick}) => {
  const {t} = useTranslation();
  // TODO: remove the usage of `useValueAfterHydration` https://aboutyou.atlassian.net/browse/ASFE-11723
  const wishlistCount = useValueAfterHydration(useWishlistCount())?.count;
  const bubbleColour = useValueAfterHydration(useWishlistBubbleColour());

  const trackFeature = useTrackFeature();
  const wishlistRoute = useWishlistRoute();
  const history = useHistory();

  const saleIndication = useMemo(() => {
    if (bubbleColour) {
      return {color: bubbleColour.hex};
    }
    return undefined;
  }, [bubbleColour]);

  return (
    <IconMetaNavigationItem
      dataTestId="Wishlist"
      icon={GenericIconName.NavHeaderWishlist}
      label={t('Wishlist')}
      count={wishlistCount}
      badgeOffset={{
        right: 0,
        top: 2,
      }}
      saleIndication={saleIndication}
      onClick={event => {
        onClick(event);
        trackFeature({eventType: 'click', label: 'wishlist_icon'});
        history.push(wishlistRoute);
      }}
    />
  );
};
